import { ACCENT } from './constants';
import { ProfessionIcon } from './profession-icon';

export const IconCreator = () => (
  <ProfessionIcon>
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 9v6h4l7 5V4L7 9H3z"
        stroke={ACCENT}
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 8.5a4 4 0 010 7"
        stroke={ACCENT}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M20 6a7 7 0 010 12"
        stroke={ACCENT}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  </ProfessionIcon>
);
